/** Sistema visual único das telas da Rede de Apoio: cabeçalho com banner, cartões, seções e status. */
const BANNERS = {
  paciente: {
    src: "/media/apoio/paciente.jpg",
    alt: "Duas pessoas se aproximando de mãos dadas em um ambiente arborizado",
  },
  boletins: {
    src: "/media/apoio/boletins.jpg",
    alt: "Profissional de saúde registrando o acompanhamento clínico",
  },
  medicamentos: {
    src: "/media/apoio/medicamentos.jpg",
    alt: "Pessoa organizando a medicação da semana em um porta-comprimidos",
  },
  alertas: {
    src: "/media/apoio/alertas.jpg",
    alt: "Mesa junto à janela com luz da manhã, transmitindo calma e atenção",
  },
};

export const PageHero = ({ kicker, title, subtitle, banner, testId }) => {
  const image = BANNERS[banner];
  return (
    <header data-testid={testId} className="er-rise">
      <p className="er-label text-[12px] tracking-[0.16em]">{kicker}</p>
      <h1 className="mt-2.5 font-display text-[28px] font-semibold leading-[1.2] tracking-tight text-ink-900">
        {title}
      </h1>
      {subtitle ? <p className="mt-2 text-[15px] leading-relaxed text-ink-600">{subtitle}</p> : null}
      {image ? (
        <img
          data-testid={`${testId}-banner`}
          src={image.src}
          alt={image.alt}
          loading="lazy"
          className="mt-5 h-[150px] w-full rounded-2xl object-cover shadow-[0_10px_30px_-18px_rgba(3,59,142,0.45)]"
        />
      ) : null}
    </header>
  );
};

export const Section = ({ label, hint, children, testId, className = "" }) => (
  <section data-testid={testId} className={className}>
    <div className="flex items-baseline justify-between gap-3">
      <h2 className="er-label text-[12px] tracking-[0.16em]">{label}</h2>
      {hint ? <span className="text-[13px] text-ink-500">{hint}</span> : null}
    </div>
    <div className="mt-3.5 space-y-3.5">{children}</div>
  </section>
);

export const Card = ({ children, testId, tone = "default", className = "", ...rest }) => (
  <div
    data-testid={testId}
    className={`rounded-2xl border bg-white p-5 shadow-[0_1px_2px_rgba(16,24,40,0.04)] transition-colors ${
      tone === "highlight" ? "border-sage-600/45 bg-sage-50/40" : "border-border"
    } ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export const CardTitle = ({ children, className = "" }) => (
  <h3 className={`font-display text-[17px] font-semibold leading-snug text-ink-900 ${className}`}>{children}</h3>
);

export const CardMeta = ({ children, testId }) => (
  <p data-testid={testId} className="text-[13px] leading-relaxed text-ink-500">
    {children}
  </p>
);

export const StatusBadge = ({ read, unreadLabel = "Não lido", readLabel = "Lido", testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex shrink-0 items-center gap-1.5 rounded-full px-3 py-1 text-[12px] font-semibold ${
      read ? "bg-success/12 text-success" : "bg-sage-600 text-white"
    }`}
  >
    {!read ? <span className="h-1.5 w-1.5 rounded-full bg-white/90" aria-hidden="true" /> : null}
    {read ? readLabel : unreadLabel}
  </span>
);

/** Botão de ação padrão do app (azul da marca, altura e paddings uniformes). */
export const ActionButton = ({ icon: Icon, children, variant = "primary", className = "", ...rest }) => (
  <button
    type="button"
    className={`inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full px-6 text-[15px] font-semibold transition-colors ${
      variant === "primary"
        ? "bg-sage-600 text-white hover:bg-sage-700"
        : "border border-sage-600/40 bg-white text-sage-700 hover:bg-sage-50"
    } ${className}`}
    {...rest}
  >
    {Icon ? <Icon size={17} aria-hidden="true" /> : null}
    {children}
  </button>
);
